<div class="modal-header" (pointerdown)="startDrag($event)">
  <div><h4 class="modal-title" id="qa-condition-title">{{_(existing ? 'Bedingung bearbeiten' : 'Bedingung einfügen')}}</h4>
    <p class="qa-condition-intro">{{_('Legen Sie fest, wann ein Text angezeigt wird.')}}</p></div>
  <button type="button" class="close" [attr.aria-label]="_(KEYS.EDITOR.CLOSE)" (click)="activeModal.dismiss()">&times;</button>
</div>
<div class="modal-body qa-condition-body">
  <div class="qa-condition-heading"><span class="qa-condition-badge">{{_('WENN')}}</span>
    <label><input type="checkbox" [(ngModel)]="unless"> {{_('Bedingung umkehren')}}</label></div>
  <ng-container *ngTemplateOutlet="node; context: {$implicit: condition}"></ng-container>
  <button *ngIf="condition.kind === 'rule'" type="button" class="btn btn-sm btn-outline-secondary qa-condition-combine"
          (click)="combine()">+ {{_('Weitere Regel')}}</button>
  <div class="qa-condition-preview" aria-live="polite">
    <strong>{{_(unless ? 'WENN NICHT' : 'WENN')}} {{summary}}</strong>
    <span><b>{{_('DANN')}}</b> {{_('Text direkt im Editor bearbeiten')}}</span>
    <label><input type="checkbox" [(ngModel)]="otherwise" [disabled]="hadOtherwise"> {{_('SONST-Bereich hinzufügen')}}</label>
    <span *ngIf="otherwise"><b>{{_('SONST')}}</b> {{_('Alternativen Text direkt im Editor bearbeiten')}}</span>
  </div>
  <details *ngIf="valid"><summary>{{_('Handlebars anzeigen')}}</summary><code class="qa-condition-source">{{source}}</code></details>
  <p *ngIf="!valid" class="qa-condition-validation" role="status">{{_('Bitte wählen Sie alle Variablen und geben Sie gültige Vergleichswerte ein.')}}</p>
  <p *ngIf="invalidText" class="qa-condition-validation">{{_(KEYS.EDITOR.CONDITION_TEXT_CHARACTERS)}}</p>
  <p *ngIf="existing" class="qa-condition-help">{{_('Beim Entfernen der Bedingung bleiben die Texte aus DANN und SONST erhalten.')}}</p>
</div>
<div class="modal-footer">
  <button *ngIf="existing" type="button" class="btn btn-outline-danger mr-auto"
          (click)="activeModal.close({unwrap: true})">{{_('Bedingung entfernen')}}</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">{{_(KEYS.EDITOR.TEXT_VARIABLE_CANCEL)}}</button>
  <button type="button" class="btn btn-primary" [disabled]="!valid" (click)="save()">{{_(existing ? 'Übernehmen' : 'Einfügen')}}</button>
</div>
<ng-template #node let-rule let-parent="parent" let-index="index">
  <div *ngIf="rule.kind === 'group'" class="qa-condition-group">
    <div class="qa-condition-group-heading">
      <select class="form-control form-control-sm" [(ngModel)]="rule.operator" [attr.aria-label]="_('Regeln verknüpfen')">
        <option value="and">{{_('Alle Regeln treffen zu (UND)')}}</option>
        <option value="or">{{_('Mindestens eine Regel trifft zu (ODER)')}}</option>
      </select>
      <button *ngIf="parent" type="button" class="qa-condition-remove" (click)="parent.children.splice(index, 1)"
              [attr.aria-label]="_('Gruppe entfernen')">&times;</button>
    </div>
    <div *ngFor="let child of rule.children; let i = index" class="qa-condition-child">
      <ng-container *ngTemplateOutlet="node; context: {$implicit: child, parent: rule, index: i}"></ng-container>
    </div>
    <div class="qa-condition-actions">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="add(rule)">+ {{_('Regel')}}</button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="add(rule, true)">+ {{_('Gruppe')}}</button>
    </div>
  </div>
  <div *ngIf="rule.kind === 'rule'" class="qa-condition-rule">
    <div class="qa-condition-rule-main">
      <button type="button" class="qa-condition-variable" (click)="choose(rule)" [attr.title]="rule.path">
        <span class="qa-condition-variable-icon">&#123; &#125;</span><span>{{name(rule.path)}}</span><span aria-hidden="true">⌄</span>
      </button>
      <select class="form-control" [(ngModel)]="rule.operator" [attr.aria-label]="_('Vergleich')">
        <option *ngFor="let comparison of comparisons" [value]="comparison">{{_(operators[comparison])}}</option>
      </select>
      <button *ngIf="parent" type="button" class="qa-condition-remove" (click)="parent.children.splice(index, 1)"
              [attr.aria-label]="_('Regel entfernen')">&times;</button>
    </div>
    <div *ngIf="needsValue(rule)" class="qa-condition-value">
      <select class="form-control" [(ngModel)]="rule.valueType" (ngModelChange)="changeType(rule)" [attr.aria-label]="_('Werttyp')">
        <option *ngFor="let type of types" [value]="type.id">{{_(type.label)}}</option>
      </select>
      <select *ngIf="rule.valueType === 'boolean'" class="form-control" [(ngModel)]="rule.value" [attr.aria-label]="_('Vergleichswert')">
        <option value="true">{{_('Ja')}}</option><option value="false">{{_('Nein')}}</option>
      </select>
      <button *ngIf="rule.valueType === 'variable'" type="button" class="qa-condition-variable" (click)="choose(rule, true)">
        {{name(rule.value)}}
      </button>
      <input *ngIf="rule.valueType !== 'boolean' && rule.valueType !== 'variable'" class="form-control"
             [type]="rule.valueType === 'date' ? 'date' : 'text'" [attr.inputmode]="rule.valueType === 'number' ? 'decimal' : null"
             [(ngModel)]="rule.value" [attr.aria-label]="_('Vergleichswert')" [placeholder]="_('Vergleichswert')">
    </div>
  </div>
</ng-template>
